import React, { Fragment, useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { createNewTag, fetchTagById, updateTag } from "../actions/tag";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import InputField from "../components/Admin/Reusable/InputField";
import languagesItems from "../utils/languages";

import { TabPanel, a11yProps } from "../helper/TabPanel";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { validateLocalesFields } from "../utils";
import { tagActions } from "../reducers/tag";
import GlobalProgressOverlay from "../components/Admin/Reusable/GlobalProgressOverlay";

const TagAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  const [activeLocaleTab, setActiveLocaleTab] = useState(0);
  const handleChangeLocaleTab = (e, newValue) => setActiveLocaleTab(newValue);
  const [errors, setErrors] = useState({});
  const { tagDetail, loading, success, actionType } = useSelector((state) => state.tagReducer);

  //locales
  // const [locales, setLocales] = useState(() =>
  //   Object.fromEntries(
  //     languagesItems.map((l) => [
  //       l.code,
  //       {
  //         id: null,
  //         name: "",
  //         language: l.code,
  //       },
  //     ])
  //   )
  // );

  const getInitialLocales = () =>
    Object.fromEntries(
      languagesItems.map((l) => [l.code, { id: null, name: "", language: l.code }])
    );

  const [locales, setLocales] = useState(getInitialLocales);


  const initialState = {
    active: true,
  };

  //osnovi podaci
  const [data, setData] = useState(initialState);
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(false);

  //breadcrumbs
  const translateForm = "tagForm";
  const translateModule = "tag";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      setLocales(getInitialLocales());
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchTagById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (tagDetail && id) {
      setData({
        ...tagDetail,
      });

      // popuni locales iz backend-a
      const filledLocales = Object.fromEntries(
        languagesItems.map((l) => {
          const found = tagDetail.locales?.find(
            (loc) =>
              loc.language === l.code || loc.language === l.label.toUpperCase()
          );
          return [
            l.code,
            {
              id: found?.id || null,
              name: found?.name || "",
              language: l.code,
            },
          ];
        })
      );

      setLocales(filledLocales);
    }
  }, [tagDetail, id, dispatch]);

   useEffect(() => {
        let interval;
        let timeout;
    
        if (loading) {
          setShowLoader(true);
          setProgress(0);
    
          interval = setInterval(() => {
            setProgress((prev) => {
              if (prev >= 100) {
                clearInterval(interval);
                return 100;
              }
              return prev + 5;
            });
          }, 100);
        } else if (!loading && showLoader) {
          setProgress(100);
          timeout = setTimeout(() => {
            setShowLoader(false);
            setProgress(0);
          }, 2000);
        }
    
        return () => {
          clearInterval(interval);
          clearTimeout(timeout);
        };
      }, [loading]);
    
    useEffect(() => {
      if (success) {
        const timeout = setTimeout(() => {
          navigate("/tag-list");
  
          if (actionType === "create") {
            toast.success("Uspešno ste kreirali novi tag", { theme: "colored" });
          } else if (actionType === "update") {
            toast.success("Uspešno ste izmenili tag", { theme: "colored" });
          }
  
          dispatch(tagActions.clearError());
        }, 2000);
  
        return () => clearTimeout(timeout);
      } else {
        dispatch(tagActions.clearError());
      }
    }, [success]); 


  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData();
    // pretvaranje locales objekta u niz za backend
    const localesArray = Object.entries(locales).map(([code, v]) => ({
      ...v,
      // ako postoji id, prosledi; ako ne, backend može generisati
      id: v.id || undefined,
    }));

    // // ❌ Provera da li je bar jedno ime prazno
    // const hasEmptyName = localesArray.some(
    //   (loc) => !loc.name || loc.name.trim() === ""
    // );

    // if (hasEmptyName) {
    //   toast.error("Morate uneti naziv kategorije za sve jezike", {
    //     theme: "colored",
    //   });
    //   return;
    // }
    const localeErrors = validateLocalesFields(locales, ["name"]);
    if (Object.keys(localeErrors).length > 0) {
        setErrors({ locales: localeErrors });
        toast.error("Morate uneti naziv kategorije za sve jezike", {
          theme: "colored",
        });
      return;
    }
  
  setErrors({});

    const dataForm = {
      ...data,
      locales: localesArray,
    };

    if (id) {
      dataForm.id = id;
    }

    if (id) {
      dispatch(updateTag(dataForm, navigate, id));
    } else {
      dispatch(createNewTag(dataForm, navigate));
    }
  };

  const updateLocale = (code, field, value) => {
    setLocales((prev) => ({
      ...prev,
      [code]: { ...prev[code], [field]: value },
    }));
  };

  const handleInputChange = (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      const name = eOrName;
      const value = maybeValue;
      setData((prev) => ({ ...prev, [name]: value }));
      return;
    }

    const e = eOrName;
    const { name, type, value, checked } = e.target;

    setData((prev) => {
      // default ažuriranje
      let next = { ...prev, [name]: type === "checkbox" ? checked : value };

      return next;
    });
  };
  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
      />
      {showLoader && <GlobalProgressOverlay progress={progress} />}
      <Container className="tag-container">
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          {/* Tabs header */}
                          <Tabs
                            value={activeLocaleTab}
                            onChange={handleChangeLocaleTab}
                            variant="scrollable"
                            // scrollButtons
                            // allowScrollButtonsMobile
                          >
                            {languagesItems.map((lng, idx) => (
                              <Tab
                                key={lng.code}
                                label={lng.label}
                                {...a11yProps(idx)}
                                // primer: pokaži zvezdicu ako fali naslov
                                iconPosition="end"
                              />
                            ))}
                          </Tabs>

                          {/* Tabs content */}
                          {languagesItems.map((lng, idx) => (
                            <TabPanel
                              key={lng.code}
                              value={activeLocaleTab}
                              index={idx}
                            >
                              <Row>
                                <input type="hidden" value={lng.id} name="id" />
                                <Col lg={12} className="mb-3">
                                  <InputField
                                    name={`name_${lng.code}`}
                                    label={`${t(`${translateForm}.name`)} `}
                                    value={locales[lng.code].name}
                                    size="small"
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    required
                                    error={errors?.locales?.[lng.code]?.name}  
                                    errorsHandler={setErrors}
                                  />
                                </Col>
                              </Row>
                            </TabPanel>
                          ))}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t(`global.settings`)}</Card.Header>
                        <Card.Body>
                          <SelectStatus
                            active={true}
                            data={data}
                            handleInputChange={handleInputChange}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TagAdd;
